module.exports = __webpack_public_path__ + "static/media/backup.763a106f.gif";